knownChanged